import { connect } from 'react-redux';

import {
  refreshPipeline,
  removeDetailViewCard,
  removeFlowFromProject,
  setDetailViewCard,
  setPipelineAction,
  setSelectedFlow,
} from 'js/actions';
import { restorePipeline } from 'new/actions/pipelines/archivalActions';

import DataFlowDetailActions from './DataFlowDetailActions';

const mapStateToProps = (state, ownProps) => {
  const flowNodeId = ownProps?.data?.['flow_node_id'] ?? null;
  const flowNode = flowNodeId ? state.entities?.flowNodes?.[flowNodeId] : null;

  return { flowNode };
};

export default connect(mapStateToProps, {
  setPipelineAction,
  setDetailViewCard,
  removeDetailViewCard,
  setSelectedFlow,
  refreshPipeline,
  removeFlowFromProject,
  restorePipeline,
})(DataFlowDetailActions);
